var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',{staticClass:"characters-text"},[_vm._v("Characters")]),_c('div',{staticClass:"characters-list"},_vm._l((_vm.characters),function(character){return _c('character-card',{key:character.characterId,attrs:{"character":character}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }